"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var S = _interopRequireWildcard(require("./styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SearchEnginePreview = function SearchEnginePreview(_ref) {
  var path = _ref.path;

  var articleCategoryLink = function articleCategoryLink(slug) {
    return "".concat(process.env.REACT_APP_STOREFRONT_URL || window.location.origin, "/").concat(path, "/").concat(slug || 'article-path');
  };

  return /*#__PURE__*/_react["default"].createElement(S.SearchEnginePreview, null, /*#__PURE__*/_react["default"].createElement(S.SearchEngineUrl, {
    "data-testid": "seo-path"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "path"
  }, function (_ref2) {
    var field = _ref2.field;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, articleCategoryLink(field.value));
  })), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "path"
  }, function (_ref3) {
    var field = _ref3.field;
    return /*#__PURE__*/_react["default"].createElement(S.SearchEngineTitle, {
      href: articleCategoryLink(field.value),
      target: "_blank",
      "data-testid": "seo-title"
    }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
      name: "title"
    }, function (_ref4) {
      var _field$value;

      var field = _ref4.field,
          form = _ref4.form;

      if (field !== null && field !== void 0 && (_field$value = field.value) !== null && _field$value !== void 0 && _field$value.length) {
        return field.value;
      } else {
        var _form$values;

        return form !== null && form !== void 0 && (_form$values = form.values) !== null && _form$values !== void 0 && _form$values.title ? form.values.title : 'Article Title';
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(S.SearchEngineDescription, {
    "data-testid": "seo-description"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "metaDescription"
  }, function (_ref5) {
    var _field$value2;

    var field = _ref5.field,
        form = _ref5.form;

    if (field !== null && field !== void 0 && (_field$value2 = field.value) !== null && _field$value2 !== void 0 && _field$value2.length) {
      return field.value;
    } else {
      return /*#__PURE__*/_react["default"].createElement("i", null, "You have no description set. Descriptions are important and can influence click-through rates. The optimal length is between 50\u2013160 characters.");
    }
  })));
};

var _default = SearchEnginePreview;
exports["default"] = _default;